// import About from "../Components/About/About";
import Carousel from "../Components/Slider/Slider";
import PillarsIslam from "../Components/PillarsIslam/PillarsIslam";
import About from "../Components/NewAbout/About";
import Services from "../Components/Services/Services";
import Founder from "../Components/OurFounder/Founder";
import Player from "../Components/AudioPlayer/Player";
const Landing = () => {
    return (
        <div>
            <Carousel />
            <div id="player">
                <Player />
            </div>
            <About />
            <PillarsIslam />
            <Services />
            <Founder />
        </div>
    );
};

export default Landing;
